import { render, staticRenderFns } from "./MagazineCardSkelton.vue?vue&type=template&id=60264c3f&scoped=true&"
var script = {}
import style0 from "./MagazineCardSkelton.vue?vue&type=style&index=0&id=60264c3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60264c3f",
  null
  
)

export default component.exports